// /* Altera todos os links de coleções para links com parametro de disponibilidade */
// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll("a[href*='/collections/']").forEach(link => {
//         let url = new URL(link.href, window.location.origin);
//         let params = url.searchParams;

//         if (!params.has('filter.v.availability') || params.get('filter.v.availability') !== '1') {
//             params.set('filter.v.availability', '1'); // Adiciona ou substitui o parâmetro
//             link.href = url.toString(); // Atualiza o link
//         }
//     });
// });

function copyToClipboard(element) {
  var $temp = $("<input>");
  var oldValue = $(element).html();

  $("body").append($temp);
  $temp.val($(element).children("span").html()).select();
  document.execCommand("copy");
  $(element).html("COPIADO");
  setTimeout(function () {
    $(element).html(oldValue);
  }, 300);
  $temp.remove();
}

$("cupom").click(function () {
  copyToClipboard(this);
});

// Seleciona todos os elementos .product dentro de #main-collection-product-grid
function updateProductBannerHeight() {
  const $products = $("#main-collection-product-grid .product:not(.banner) ");
  const $productBanner = $(".product.banner");

  if ($products.length > 0 && $productBanner.length > 0) {
    // Calcula a maior altura entre os produtos
    let maxHeight = 0;
    $products.each(function () {
      const productHeight = $(this).outerHeight();
      if (productHeight > maxHeight) {
        maxHeight = productHeight;
      }
    });

    // Adiciona a maior altura ao elemento .product.banner
    $productBanner.css("height", maxHeight + "px");
  } else {
    console.warn("Nenhum produto encontrado ou .product.banner ausente.");
  }
}

$(document).ready(() => {
  // Atualiza a altura ao carregar a página
  updateProductBannerHeight();

  $(window).on("resize", function () {
    updateProductBannerHeight();
  });

  tippy("[data-tippy-content]", {
    placement: "bottom",
  });

  $("#HeaderNavigation .menu-lv-1.has-megamenu").hover(function () {
    const $submenu = $(this).find(".menu-dropdown");
    if ($submenu.length) {
      const rect = $submenu[0].getBoundingClientRect();
      const windowWidth = $(window).width();

      // Verifica se ultrapassa os limites da janela
      const overflowRight = rect.right - windowWidth;
      const overflowLeft = -rect.left;

      if (overflowRight > 0) {
        // Ajusta o 'left' para compensar o excesso à direita
        const newLeft = parseInt($submenu.css("left") || 0) - overflowRight;
        $submenu.css({ left: `${newLeft}px`, right: "unset" });
      }

      if (overflowLeft > 0) {
        // Ajusta o 'left' para compensar o excesso à esquerda
        const newLeft = parseInt($submenu.css("left") || 0) + overflowLeft;
        $submenu.css({ left: `${newLeft}px`, right: "unset" });
      }
    }
  });

  $(".header-mobile__item.header-mobile__item--menu").on("click", () =>
    $(document.body).toggleClass("menu_open")
  );

  // UPSELL Carrinho
  window.upsellSliderInit = function () {
    // $(".recommend-slider .swiper-wrapper").slick({
    //   slidesToShow: 3,
    //   slidesToScroll: 3,
    //   variableWidth: true,
    //   dots: true,
    //   infinite: false,
    //   arrows: true,
    //   prevArrow: ".swiper-button-prev",
    //   nextArrow: ".swiper-button-next",
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         variableWidth: true,
    //         centerMode: false,
    //       },
    //     },
    //   ],
    // });

    Fancybox.bind("[data-fancybox*='upsell']", {
      dragToClose: false,
      parentEl: $(document.body).hasClass("template-cart")
        ? document.querySelector(`body`)
        : document.querySelector(".halo-cart-sidebar"),
      closeButton: false,
    });

    $(".recommend-container").addClass("loaded");
  };

  function beforeSend(element) {
    $("#dropdown-cart").addClass("updating-cart");
    $(element).find(".recommend-btn-add").addClass("is-loading");
  }

  function afterSend(element) {
    $("#dropdown-cart").removeClass("updating-cart");
    $(element).find(".recommend-btn-add").removeClass("is-loading");
  }

  $(document).on("submit", ".upsell-form", function (e) {
    e.preventDefault();

    const formData = new FormData(this);
    const serializedData = {};
    formData.forEach((value, key) => {
      serializedData[key] = value;
    });
    const jsonData = JSON.stringify(serializedData);

    // URL da API da Shopify para adicionar um item ao carrinho
    const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

    // Opções da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonData,
    };

    beforeSend(e.target); // Ação "before send" antes da requisição

    // Faz a requisição usando fetch com ação "before send" e "after send"
    fetch(addToCartUrl, requestOptions)
      .then((response) => {
        afterSend(); // Ação "after send" após a conclusão da requisição

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        Fancybox.close();

        if ($(document.body).hasClass("template-cart")) {
          window.location.reload();
        } else {
          // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
          Shopify.getCart(window.updateCart);
          $("body").addClass("cart-sidebar-show");
        }
      })
      .catch((error) => {
        // Houve um erro na requisição, você pode tratar o erro aqui
        console.error("Error:", error);
      });
  });

  $(document).on("change", ".variants-product-selects select", function () {
    var $currentSelect = $(this);
    var $nextSelect = $currentSelect
      .closest(".variants-product-selects")
      .find("select")
      .eq($currentSelect.index() + 1);

    if (
      $nextSelect.length &&
      $nextSelect.is(":hidden") &&
      $nextSelect.find("option").length > 1
    ) {
      $nextSelect.show();
    } else {
      var selectedOptions = $currentSelect
        .closest(".variants-product-selects")
        .find("select")
        .map(function () {
          return $(this).val();
        })
        .get();
      var productData = JSON.parse(
        $currentSelect
          .closest(".variants-product-selects")
          .find("[data-json-product]")
          .text()
      );

      var matchingVariant = productData.find(function (variant) {
        return selectedOptions.every(function (option, index) {
          return variant.options[index] === option;
        });
      });

      if (matchingVariant && matchingVariant.available) {
        $currentSelect
          .closest(".variants-product-selects")
          .find(".variantIdAddCart")
          .val(matchingVariant.id);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .prop("disabled", false);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .val("ADICIONAR");
      } else {
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .prop("disabled", true);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .val("ESGOTADO");
      }
    }

    var container = $(".halo-cart-sidebar").find(".previewCart");
    var scrollTo = $(".halo-cart-sidebar").find(".recommend-container");

    // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
    var scrollPosition =
      scrollTo.offset().top +
      scrollTo.outerHeight() +
      container.scrollTop() -
      container.position().top;

    // Realiza a rolagem
    container.animate(
      {
        scrollTop: scrollPosition,
      },
      1000
    ); // 1000 milissegundos para a animação de rolagem
  });
});

(function ($) {
  let searchParams = new URLSearchParams(window.location.search);
  let cartOpen = searchParams.has("cart_show");

  if (cartOpen) {
    $(document.body).addClass("cart-sidebar-show");
  }

  function error_ship_ajax(msg) {
    var $input_cep = $(".zipcode-input"),
      $input_container = $(".cart-drawer__footer__row"),
      $erro_ship = $(".erro-shipping");

    $input_cep.val("");
    $input_container.addClass("error-input");

    if (msg.length > 0) {
      $erro_ship.html(msg);
    }
    setTimeout(function () {
      $input_container.removeClass("error-input");
      $erro_ship.html("");
    }, 4000);
  }

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

  function updateCartCookie(a) {
    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "cart=" + a + expires + "; path=/";
  }

  function resetCartCookie(cartCookie) {
    console.log("reset cart cookie")
    updateCartCookie(cartCookie);
  };

  function shipping_ajax() {
    var $input_cep = $(".zipcode-input"),
      $shipping_list = $(".shipping_options__list"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $container_ship_name = $(".shipping-rate-name");

    var $cep = $input_cep.val().replace(/\D/g, "");
    var $validacep = /^[0-9]{8}$/;

    console.log($validacep.test($cep));
    if ($cep == "") {
      error_ship_ajax("Campo cep está vazio");
      return;
    }

    if (!$validacep.test($cep)) {
      error_ship_ajax("Cep inválido");
      return;
    }

    const cartCookie = getCookie('cart');
    var tempCookieValue = "temp-cart-cookie___" + Date.now();
    var fakeCookieValue = "fake-cart-cookie___" + Date.now();

    /* if not found, make a new temp cookie */
    if (!cartCookie) {
      updateCartCookie(tempCookieValue);
      cartCookie = getCookie('cart');
    }

    updateCartCookie(fakeCookieValue);

    console.log("Cart Cookie: ", cartCookie);
    console.log("Cart Cookie Temp: ", getCookie(fakeCookieValue));

    let addData = {
      "items": [],
    };
    const lineItems = document.querySelectorAll("[data-item-row]");

    lineItems.forEach(function (item) {
      const variantId = item.dataset.variantId;
      const quantity = item.dataset.quantity;

      addData.items.push({
        id: variantId,
        quantity: quantity
      });
    });

    fetch('/cart/add.js?_easygift_internal=true', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
      },
      method: 'POST'
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      $.getJSON(
        "https://viacep.com.br/ws/" + $cep + "/json/?callback=?",
        function (dados) {
          if ("erro" in dados) {
            console.log("Erro na consulta, confira o cep e tente novamente");
            return;
          }

          switch (dados.uf) {
            case "AC":
              dados.uf = "Acre";
              break;
            case "AL":
              dados.uf = "Alagoas";
              break;
            case "AP":
              dados.uf = "Amapa";
              break;
            case "AM":
              dados.uf = "Amazonas";
              break;
            case "BA":
              dados.uf = "Bahia";
              break;
            case "CE":
              dados.uf = "Ceara";
              break;
            case "DF":
              dados.uf = "Distrito Federal";
              break;
            case "ES":
              dados.uf = "Espirito Santo";
              break;
            case "GO":
              dados.uf = "Goias";
              break;
            case "MA":
              dados.uf = "Maranhao";
              break;
            case "MT":
              dados.uf = "Mato Grosso";
              break;
            case "MS":
              dados.uf = "Mato Grosso do Sul";
              break;
            case "MG":
              dados.uf = "Minas Gerais";
              break;
            case "PA":
              dados.uf = "Para";
              break;
            case "PB":
              dados.uf = "Paraiba";
              break;
            case "PR":
              dados.uf = "Parana";
              break;
            case "PE":
              dados.uf = "Pernambuco";
              break;
            case "PI":
              dados.uf = "Piaui";
              break;
            case "RJ":
              dados.uf = "Rio de Janeiro";
              break;
            case "RN":
              dados.uf = "Rio Grande do Norte";
              break;
            case "RS":
              dados.uf = "Rio Grande do Sul";
              break;
            case "RO":
              dados.uf = "Rondonia";
              break;
            case "RR":
              dados.uf = "Roraima";
              break;
            case "SC":
              dados.uf = "Santa Catarina";
              break;
            case "SP":
              dados.uf = "Sao Paulo";
              break;
            case "SE":
              dados.uf = "Sergipe";
              break;
            case "TO":
              dados.uf = "Tocantins";
              break;
          }

          $.ajax({
            type: "GET", //rest Type
            dataType: "json", //mispelled
            url:
              "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" +
              $cep +
              "&shipping_address%5Bcountry%5D=" +
              "Brazil" +
              "&shipping_address%5Bprovince%5D=" +
              dados.uf,
            beforeSend: function () {
              $(".overlay-carregando").show();
            },
            success: function (msg) {
              $(".overlay-carregando").hide();
              $shipping_list.html("");
              // $ship_name_display.html(msg.shipping_rates[0].name);
              // if($('.shipping-display.value') === 0.00){
              //   $('.shipping-display.value').html("Grátis");
              // }else{
              //   $('.shipping-display.value').html(Shopify.formatMoney(msg.shipping_rates[0].price, window.money_format));
              // }
              var freeThreshold = Number(window.free_shipping_price + "00") || 0; // valor-mínimo para frete grátis
              var cartTotal = Number(window.cart_total_price || 0); // total do carrinho (defina antes!)
              var qualifiesForFree = cartTotal >= freeThreshold;
                
              for (i = 0; i < msg.shipping_rates.length; i++) {
                let $formatedPrice;
                let $estimateShip;
                if (msg.shipping_rates[i].price === 0.0 || qualifiesForFree) {
                  $formatedPrice = "<b>Grátis</b>";
                } else {
                  $formatedPrice = Shopify.formatMoney(
                    msg.shipping_rates[i].price,
                    window.money_format
                  );
                }
                var $priceShip = msg.shipping_rates[i].price;
                if (
                  msg.shipping_rates[i].delivery_days[1] == null ||
                  msg.shipping_rates[i].delivery_days[1] === 0
                ) {
                  $estimateShip = "";
                } else {
                  $estimateShip =
                    "Em até " +
                    msg.shipping_rates[i].delivery_days[1] +
                    " dias úteis";
                }

                var $template =
                  '<li data-shipping-change class="filters-group__list__item"> <label for="shipping-option_' +
                  msg.shipping_rates[i].name
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/-$/, "")
                    .replace(/^-/, "") +
                  '" class="filters-checkbox"> <input type="radio" name="shipping_id" value="shippingId" id="shipping-option_' +
                  msg.shipping_rates[i].name
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/-$/, "")
                    .replace(/^-/, "") +
                  '" data-name="' +
                  msg.shipping_rates[i].name +
                  '" data-price="' +
                  msg.shipping_rates[i].price +
                  '" data-formatted-price="' +
                  $formatedPrice +
                  '" data-delivery="' +
                  $estimateShip +
                  '"> <span class="check"></span> <span class="text">' +
                  msg.shipping_rates[i].name +
                  " - " +
                  $formatedPrice +
                  " (" +
                  $estimateShip +
                  ")</span> </label> </li>";

                $shipping_list.append($template);

                //$("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
              }
              // $display_shipping.removeClass('hidden');
              // $ship_name_display.removeClass('hidden');
              $shipping_list_container.removeClass("hidden");
              resetCartCookie(cartCookie)
            },
            error: function (erro) {
              resetCartCookie(cartCookie)
              $(".overlay-carregando").hide();
              console.log(
                "Erro ao consultar os fretes disponíveis, tente novamente"
              );
            },
          });
        }
      );
    }).catch(function (err) {
      /* uh oh, we have error. */
      console.error(err);
      resetCartCookie(cartCookie)
    });


  }

  function select_ship(selected) {
    var name = selected.data("name"),
      price = selected.data("price"),
      formated_price = selected.data("formatted-price"),
      delivery = selected.data("delivery"),
      total_container = $("[data-cart-total-value]"),
      subtotal_price = $("[data-cart-subtotal]").attr("data-cart-subtotal");

    var $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $ship_price_display = $(".shipping-display.value"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping");

    var shippingNumbers = price.toString().replaceAll(".", "");
    shippingNumbers = parseInt(shippingNumbers);

    total_container.html(
      Shopify.formatMoney(
        parseInt($("[data-cart-total-value]").data("cart-total-value")) +
        shippingNumbers,
        window.money_format
      )
    );
    $ship_name_display.html(name);
    $ship_price_display.html(formated_price);

    $display_shipping.removeClass("hidden");
    $ship_name_display.removeClass("hidden");
    $shipping_list_container.addClass("hidden");
    $btn_calc.addClass("hidden");
    $btn_change.removeClass("hidden");
  }

  function show_rate_list() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options");
    $shipping_list_container.removeClass("hidden");
  }

  function reset_ship() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping"),
      $input_cep = $(".zipcode-input");

    $shipping_list_container.addClass("hidden");
    $display_shipping.addClass("hidden");
    $btn_change.addClass("hidden");
    $btn_calc.removeClass("hidden");
    $input_cep.val("").focus();
  }

  $(document).on("click", ".calculate-shipping", function (e) {
    shipping_ajax();
  });

  $(document).on("click", ".recalculate-shipping", function (e) {
    reset_ship();
  });

  $(document).on("click", "[data-shipping-change]", function (e) {
    select_ship($(this).find("input"));
  });

  $(document).on("click", ".show-rates-list", function (e) {
    show_rate_list();
  });

  $(document).on("click", "[hide-filters]", function (e) {
    $(".background-overlay").trigger("click");
  });

  $(document).on("input", ".zipcode-input", function () {
    if (!$(this).val().length > 0) {
      reset_ship();
    }
  });

  function updateAnchorsTarget() {
    const selectors = [
      ".footer a",
      ".header-navigation a",
      ".header__inline-menu a",
    ];
    const anchors = document.querySelectorAll(selectors.join(", "));
    const keywords = ["blog.mooui.com.br", "programa-de-arquitetos", "atacado"];

    anchors.forEach((anchor) => {
      if (keywords.some((keyword) => anchor.href.includes(keyword))) {
        anchor.setAttribute("target", "_blank");
      }
    });
  }

  // Executa no carregamento e na mudança de tamanho da janela
  window.addEventListener("load", updateAnchorsTarget);
  window.addEventListener("resize", updateAnchorsTarget);

  if (document.body.classList.contains("template-product")) {
    const variantInputs = document.querySelectorAll(".product-form__radio");

    variantInputs.forEach((varInput) => {
      varInput.addEventListener("change", () => {
        if (varInput.checked) {
          if (
            varInput.dataset.variantInventory > 0 &&
            varInput.dataset.variantInventory <= 5
          ) {
            document.querySelector(".few-remaining").classList.remove("hidden");
            document.querySelector(".few-remaining").textContent =
              varInput.dataset.variantInventory == 1
                ? "Resta 1 unidade"
                : `Restam ${varInput.dataset.variantInventory} unidades`;
          } else {
            document.querySelector(".few-remaining").classList.add("hidden");
          }
        }
      });
    });
  }

  window.addEventListener("load", function () {
    const body = document.body;
    const urlParams = new URLSearchParams(window.location.search);
    const page = parseInt(urlParams.get("page"), 10);

    if (body.classList.contains("template-collection") && page >= 2) {
      const targetElement = document.querySelector(".collection-banner-adv");
      if (targetElement) {
        const offset = 180;
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    }
  });
})(jQuery);
